import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { DataSource } from '@angular/cdk/collections';
import { MdPaginator, MdSnackBar, PageEvent } from '@angular/material';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';
import { Configurations } from "../../core/configurations";
import { UserSearchModel } from './../../models/user/user-search.model';
import { UserListItemModel } from './../../models/user/user-list-item.model';
import { UserService } from './../../services/user.service';
import { AuthService } from './../../services/auth.service';

import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UltimaVersioneApplicativoClientService } from '../../services/ultima-versione-applicativo-client.service';

@Component({
  selector: 'app-utenti-list',
  templateUrl: './utenti-list.component.html',
  styleUrls: ['./utenti-list.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class UtentiListComponent implements OnInit {

  isLoading = false;
  utenti: UserListItemModel[];
  model: UserSearchModel = null;
  dataSource: UtentiDataSource = null;



  displayedColumns = ['id', 'username', 'nominativo', 'attivo', 'daConfermare', 'accessoIncassi', 'accessoVersamenti', 'impersonifica'];
  numeroRisultati = 0;
  pageEvent: PageEvent;
  numeroPagine: number = 0;

  @ViewChild(MdPaginator) paginator: MdPaginator;

  constructor(
    private configuration: Configurations,
    private utentiService: UserService,
    private authService: AuthService,
    private snackBar: MdSnackBar,
    private _ultimaVersioneClientTipo: UltimaVersioneApplicativoClientService,
  ) { }

  ngOnInit() {
    this._ultimaVersioneClientTipo.getUltimaVersioneApplicativo()
      .subscribe(data => {
        Configurations.currentVersionCod = data.codice;
        let v = localStorage.getItem('clientVersion');
        if (v === null || v === undefined || v !== data.codice) {
          localStorage.setItem('clientVersion', data.codice);
          alert("Sono state pubblicate delle modifiche nel portale, per poterle caricare verrà indirizzato alla homepage.");
          window.location.href = Configurations.baseUrl;
        }
      });

    initDatePicker();
    this.model = new UserSearchModel();
  }

  search() {
    this.numeroRisultati = 0;
    this.isLoading = true;

    this.model.pageNumber = this.paginator.pageIndex + 1;
    this.model.pageSize = this.paginator.pageSize;

    this.utentiService.getList(this.model)
      .finally(() => this.isLoading = false)
      .subscribe((r: any) => {

        this.utenti = r.utentiTrovati as UserListItemModel[];
        console.log(JSON.stringify(this.utenti));
        this.dataSource = new UtentiDataSource(this.utenti, this.paginator, this.model);
        this.numeroRisultati = this.utenti.length;
        this.numeroPagine = r.numeroPagineTotali;

      },
        (err) => {
          this.showError("Errore durante la procedura di ricerca.");
        });
  }

  onPaginateChange(event) {
    this.model.pageNumber = this.paginator.pageIndex + 1;
    this.model.pageSize = this.paginator.pageSize;
    this.search();
  }

  abilitaPermesso(token, abilitazione) {
    this.isLoading = true;
    this.utentiService.updateAbilitazioneUtente(token, 'Clienti.View', abilitazione)
      .finally(() => this.isLoading = false)
      .subscribe(
        (r: any) => {
          if (r.hasAuthorizationChanged) {
            this.utenti = r;
            this.dataSource = null;
            //new UtentiDataSource(this.utenti, this.paginator, this.model);
            this.numeroRisultati = r.length;
            this.showInfo("Autorizzazione cambiata con successo");

          }
          this.search();
        },
        err => {
          this.showError("Errore nell'abilitazione del permesso");
        }
      );
  }
  abilitaPermessoDistintaVersamenti(token, abilitazione) {
    this.isLoading = true;
    this.utentiService.updateAbilitazioneUtente(token, 'DistVers.View', abilitazione)
      .finally(() => this.isLoading = false)
      .subscribe(
        (r: any) => {
          if (r.hasAuthorizationChanged) {
            this.utenti = r;
            this.dataSource = null;
            //new UtentiDataSource(this.utenti, this.paginator, this.model);
            this.numeroRisultati = r.length;
            this.showInfo("Autorizzazione cambiata con successo");

          }
          this.search();
        },
        err => {
          this.showError("Errore nell'abilitazione del permesso");
        }
      );
  }
  impersonateUtente(id, active, toConfirm) {
    if (toConfirm || !active) {
      this.showError("Impossibile impersonificare un utente non abilititato o da confermare");
      return;
    }
    this.isLoading = true;
    this.authService.impersonateUser(id)
      .finally(() => {
        this.isLoading = false;
      })
      .subscribe(
        data => {
          if (data.isAuthenticated) {
            window.location.href = Configurations.baseUrl;
          } else {
            if (!data.loginIncorrect || data.passwordExpired) {
              this.showError(data.messaggio);
            } else if (data.passwordExpired === true) {
              this.showError("Password scaduta");
            } else if (data.userMustBeActivated === true) {
              this.showError("Utente non attivo");
            }
          }

        },
        error => {
          this.showError("Dati di accesso non validi");
        });

  }


  private showError(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 4000 });
  }

  private showInfo(msg: string) {
    this.snackBar.open(msg, 'Chiudi', { duration: 3000 });
  }

}

export class UtentiDataSource extends DataSource<any> {
  isLoading = false;

  constructor(private data: UserListItemModel[], private _paginator: MdPaginator, private model: UserSearchModel) {
    super();
  }
  connect(): Observable<UserListItemModel[]> {

    return Observable.of(this.data);
  }

  disconnect() { }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utenti/utenti-list.component.ts